(function () {
  var galleryVersion = '2026-07-26-gallery-cards-v4-collection-video';
  document.documentElement.setAttribute('data-rz-gallery-version', galleryVersion);
  if (window.RevoZportGallerySystem && window.RevoZportGallerySystem.version === galleryVersion) return;

  function option(value, label) {
    var item = document.createElement('option');
    item.value = value;
    item.textContent = label;
    return item;
  }

  function activeProgram(section) {
    var active = section.querySelector('button[data-gallery-program].is-active');
    return active ? active.getAttribute('data-gallery-program') : 'all';
  }

  function uniqueValues(cards, valueAttribute, labelAttribute, predicate) {
    var map = {};
    cards.forEach(function (card) {
      if (!predicate || predicate(card)) {
        var value = card.getAttribute(valueAttribute);
        var label = card.getAttribute(labelAttribute);
        if (value && label) map[value] = label;
      }
    });

    return Object.keys(map)
      .map(function (value) {
        return { value: value, label: map[value] };
      })
      .sort(function (a, b) {
        return a.label.localeCompare(b.label);
      });
  }

  function refill(select, firstLabel, values, preferredValue) {
    if (!select) return;
    select.innerHTML = '';
    select.appendChild(option('all', firstLabel));
    values.forEach(function (item) {
      select.appendChild(option(item.value, item.label));
    });
    if (preferredValue && values.some(function (item) { return item.value === preferredValue; })) {
      select.value = preferredValue;
    }
  }

  function programMatches(card, program) {
    return program === 'all' || card.getAttribute('data-gallery-program') === program;
  }

  function sortCards(section) {
    var grid = section.querySelector('.rz-gallery__grid');
    if (!grid) return;
    var cards = Array.prototype.filter.call(grid.children, function (child) {
      return child.hasAttribute('data-gallery-card');
    });
    cards
      .map(function (card, index) {
        return {
          card: card,
          index: index,
          priority: Number(card.getAttribute('data-gallery-priority') || 0)
        };
      })
      .sort(function (a, b) {
        return b.priority - a.priority || a.index - b.index;
      })
      .forEach(function (item) {
        grid.appendChild(item.card);
      });
  }

  function classifyGalleryImage(image) {
    var figure = image.closest('.rz-gallery__figure');
    if (!figure || !image.naturalWidth || !image.naturalHeight) return;
    var ratio = image.naturalHeight / image.naturalWidth;
    figure.classList.remove('rz-gallery__figure--portrait', 'rz-gallery__figure--landscape', 'rz-gallery__figure--square');
    figure.style.setProperty('--rz-media-ratio', image.naturalWidth + ' / ' + image.naturalHeight);
    if (ratio >= 1.12) figure.classList.add('rz-gallery__figure--portrait');
    else if (ratio <= 0.89) figure.classList.add('rz-gallery__figure--landscape');
    else figure.classList.add('rz-gallery__figure--square');
  }

  function classifyGalleryVideo(video) {
    var figure = video.closest('.rz-gallery__figure');
    if (!figure || !video.videoWidth || !video.videoHeight) return;
    var ratio = video.videoHeight / video.videoWidth;
    figure.classList.remove('rz-gallery__figure--portrait-video', 'rz-gallery__figure--landscape-video');
    figure.style.setProperty('--rz-media-ratio', video.videoWidth + ' / ' + video.videoHeight);
    if (ratio >= 1.12) {
      figure.classList.add('rz-gallery__figure--portrait-video');
      var dialog = figure.closest('.rz-gallery__dialog');
      if (dialog && figure.parentElement.querySelectorAll('.rz-gallery__figure').length === 1) {
        dialog.classList.add('rz-gallery__dialog--single-portrait');
      }
    } else {
      figure.classList.add('rz-gallery__figure--landscape-video');
    }
  }

  function hydrateDialog(dialog) {
    if (!dialog || dialog.getAttribute('data-gallery-media-ready') === 'true') return;

    dialog.querySelectorAll('img[data-gallery-deferred]').forEach(function (image) {
      var srcset = image.getAttribute('data-srcset');
      var src = image.getAttribute('data-src');
      var classify = function () {
        classifyGalleryImage(image);
        image.removeEventListener('load', classify);
      };
      image.addEventListener('load', classify);
      if (srcset) image.setAttribute('srcset', srcset);
      if (image.hasAttribute('data-gallery-lead')) image.setAttribute('fetchpriority', 'high');
      if (src) image.setAttribute('src', src);
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
      if (image.complete) classify();
    });

    dialog.querySelectorAll('video[data-gallery-deferred-video]').forEach(function (video) {
      var classifyVideo = function () {
        classifyGalleryVideo(video);
        video.removeEventListener('loadedmetadata', classifyVideo);
      };
      video.addEventListener('loadedmetadata', classifyVideo);
      var poster = video.getAttribute('data-poster');
      if (poster) {
        video.setAttribute('poster', poster);
        video.removeAttribute('data-poster');
      }
      video.querySelectorAll('source[data-src]').forEach(function (source) {
        source.setAttribute('src', source.getAttribute('data-src'));
        source.removeAttribute('data-src');
      });
      video.removeAttribute('data-gallery-deferred-video');
      video.load();
      if (video.readyState >= 1) classifyVideo();
    });

    dialog.setAttribute('data-gallery-media-ready', 'true');
  }

  function showDialog(dialog, opener) {
    if (!dialog || dialog.hasAttribute('open')) return false;
    if (opener) dialog.__rzGalleryOpener = opener;
    hydrateDialog(dialog);

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      var backdrop = document.createElement('div');
      backdrop.className = 'rz-gallery__fallback-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.addEventListener('click', function () { closeDialog(dialog); });
      document.body.appendChild(backdrop);
      dialog.__rzGalleryBackdrop = backdrop;
      dialog.classList.add('is-fallback-open');
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('open', '');
    }

    document.body.classList.add('rz-gallery-dialog-open');
    var leadVideo = dialog.querySelector('.rz-gallery__figure--lead video');
    if (leadVideo) {
      var playPromise = leadVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
    }
    var closeButton = dialog.querySelector('[data-gallery-close]');
    if (closeButton && typeof closeButton.focus === 'function') closeButton.focus();
    return true;
  }

  function rebuildMakes(section, preferredMake, preferredModel) {
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-card]'));
    var program = activeProgram(section);
    var makeSelect = section.querySelector('select[data-gallery-make]');
    var makes = uniqueValues(cards, 'data-gallery-make', 'data-gallery-make-label', function (card) {
      return programMatches(card, program);
    });

    refill(makeSelect, 'All makes', makes, preferredMake);
    rebuildModels(section, preferredModel);
  }

  function rebuildModels(section, preferredModel) {
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-gallery-card]'));
    var program = activeProgram(section);
    var makeSelect = section.querySelector('select[data-gallery-make]');
    var modelSelect = section.querySelector('select[data-gallery-model]');
    var make = makeSelect ? makeSelect.value : 'all';
    var models = uniqueValues(cards, 'data-gallery-model', 'data-gallery-model-label', function (card) {
      var cardMake = card.getAttribute('data-gallery-make');
      return programMatches(card, program) && (make === 'all' || make === cardMake);
    });

    refill(modelSelect, 'All models', models, preferredModel);
  }

  function updateUrl(section) {
    if (section.getAttribute('data-gallery-sync-url') !== 'true') return;
    var url = new URL(window.location.href);
    var program = activeProgram(section);
    var makeSelect = section.querySelector('select[data-gallery-make]');
    var modelSelect = section.querySelector('select[data-gallery-model]');
    var make = makeSelect ? makeSelect.value : 'all';
    var model = modelSelect ? modelSelect.value : 'all';

    if (program === 'all') url.searchParams.delete('program');
    else url.searchParams.set('program', program);
    if (make === 'all') url.searchParams.delete('make');
    else url.searchParams.set('make', make);
    if (model === 'all') url.searchParams.delete('model');
    else url.searchParams.set('model', model);

    window.history.replaceState({}, '', url.toString());
  }

  function applyFilters(section, syncUrl) {
    var program = activeProgram(section);
    var makeSelect = section.querySelector('select[data-gallery-make]');
    var modelSelect = section.querySelector('select[data-gallery-model]');
    var make = makeSelect ? makeSelect.value : 'all';
    var model = modelSelect ? modelSelect.value : 'all';
    var visible = 0;

    section.querySelectorAll('[data-gallery-card]').forEach(function (card) {
      var matches = programMatches(card, program)
        && (make === 'all' || card.getAttribute('data-gallery-make') === make)
        && (model === 'all' || card.getAttribute('data-gallery-model') === model);
      card.hidden = !matches;
      if (matches) visible += 1;
    });

    var count = section.querySelector('[data-gallery-count]');
    if (count) count.textContent = visible + (visible === 1 ? ' case' : ' cases');
    var empty = section.querySelector('[data-gallery-empty]');
    if (empty) empty.hidden = visible !== 0;
    if (syncUrl) updateUrl(section);
  }

  function setProgram(section, program) {
    var found = false;
    section.querySelectorAll('button[data-gallery-program]').forEach(function (button) {
      var active = button.getAttribute('data-gallery-program') === program;
      if (active) found = true;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (!found) {
      var all = section.querySelector('button[data-gallery-program="all"]');
      if (all) {
        all.classList.add('is-active');
        all.setAttribute('aria-pressed', 'true');
      }
    }
  }

  function initialize(section) {
    if (section.getAttribute('data-gallery-ready') === 'true') return;
    section.setAttribute('data-gallery-ready', 'true');

    var params = new URL(window.location.href).searchParams;
    var configuredProgram = section.getAttribute('data-gallery-default-program') || 'all';
    var urlProgram = (params.get('program') || '').toLowerCase();
    var program = configuredProgram === 'all' && (urlProgram === 'street' || urlProgram === 'race')
      ? urlProgram
      : configuredProgram;
    var preferredMake = (params.get('make') || '').toLowerCase();
    var preferredModel = (params.get('model') || '').toLowerCase();

    sortCards(section);
    setProgram(section, program);
    rebuildMakes(section, preferredMake, preferredModel);
    applyFilters(section, false);

    section.querySelectorAll('[data-gallery-dialog]').forEach(function (dialog) {
      if (dialog.getAttribute('data-gallery-events-ready') === 'true') return;
      dialog.setAttribute('data-gallery-events-ready', 'true');
      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeDialog(dialog);
      });
      dialog.addEventListener('close', function () {
        if (!document.querySelector('.rz-gallery__dialog[open]')) {
          document.body.classList.remove('rz-gallery-dialog-open');
        }
      });
    });

    var requestedCase = params.get('case');
    if (requestedCase) {
      var dialog = section.querySelector('[data-gallery-dialog-handle="' + CSS.escape(requestedCase) + '"]');
      if (dialog) showDialog(dialog);
    }
  }

  function initializeAll(root) {
    root.querySelectorAll('.rz-gallery[data-gallery-system]').forEach(initialize);
  }

  function openDialog(button) {
    var section = button.closest('.rz-gallery');
    var id = button.getAttribute('data-gallery-open');
    var dialog = document.getElementById(id);
    if (!showDialog(dialog, button)) return;

    if (section && section.getAttribute('data-gallery-sync-url') === 'true') {
      var url = new URL(window.location.href);
      url.searchParams.set('case', dialog.getAttribute('data-gallery-dialog-handle'));
      window.history.replaceState({}, '', url.toString());
    }
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.hasAttribute('open')) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      dialog.removeAttribute('aria-modal');
      dialog.classList.remove('is-fallback-open');
    }
    if (dialog.__rzGalleryBackdrop) {
      dialog.__rzGalleryBackdrop.remove();
      dialog.__rzGalleryBackdrop = null;
    }
    if (!document.querySelector('.rz-gallery__dialog[open]')) {
      document.body.classList.remove('rz-gallery-dialog-open');
    }
    dialog.querySelectorAll('video').forEach(function (video) {
      video.pause();
      if (!video.classList.contains('rz-gallery__card-video')) video.currentTime = 0;
    });
    var section = dialog.closest('.rz-gallery');
    if (section && section.getAttribute('data-gallery-sync-url') === 'true') {
      var url = new URL(window.location.href);
      url.searchParams.delete('case');
      window.history.replaceState({}, '', url.toString());
    }
    if (dialog.__rzGalleryOpener && typeof dialog.__rzGalleryOpener.focus === 'function') {
      dialog.__rzGalleryOpener.focus();
      dialog.__rzGalleryOpener = null;
    }
  }

  document.addEventListener('click', function (event) {
    var programButton = event.target.closest('button[data-gallery-program]');
    if (programButton) {
      var programSection = programButton.closest('.rz-gallery');
      setProgram(programSection, programButton.getAttribute('data-gallery-program'));
      rebuildMakes(programSection);
      applyFilters(programSection, true);
      return;
    }

    var openButton = event.target.closest('[data-gallery-open]');
    if (openButton) {
      openDialog(openButton);
      return;
    }

    var closeButton = event.target.closest('[data-gallery-close]');
    if (closeButton) {
      closeDialog(closeButton.closest('dialog'));
      return;
    }

    if (event.target.matches('.rz-gallery__dialog')) closeDialog(event.target);
  });

  document.addEventListener('change', function (event) {
    var makeSelect = event.target.closest('select[data-gallery-make]');
    if (makeSelect) {
      var makeSection = makeSelect.closest('.rz-gallery');
      rebuildModels(makeSection);
      applyFilters(makeSection, true);
      return;
    }

    var modelSelect = event.target.closest('select[data-gallery-model]');
    if (modelSelect) applyFilters(modelSelect.closest('.rz-gallery'), true);
  });

  document.addEventListener('keydown', function (event) {
    var openDialogElement = document.querySelector('.rz-gallery__dialog[open]');
    if (!openDialogElement) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeDialog(openDialogElement);
      return;
    }

    if (!openDialogElement.classList.contains('is-fallback-open')) return;
    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(openDialogElement.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    ));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });

  window.RevoZportGallerySystem = { version: galleryVersion, initialize: initializeAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }
})();
